<div class="baustein-content">
  <div class="row">

    <form [hidden]="!this.hasOptionsToShow()" *ngIf="ContentConfig.selectionFields != null">
      <ng-container *ngFor="let dropdownConfig of dropdownConfigs">
        <app-dropdown [disabled]="this.apiSvc.isBusy || (!this.getTariffOption().active && !this.getTariffOption().disabled)" (changed)="this.onTariffChanged()" [fields]="this.getTariffOption().fields" [dropdownConfig]="dropdownConfig"></app-dropdown>
      </ng-container>
      <ng-container *ngFor="let radioConfig of radioConfigs">
        <app-radio [disabled]="this.apiSvc.isBusy || (!this.getTariffOption().active && !this.getTariffOption().disabled)" (changed)="this.onTariffChanged()" [fields]="this.getTariffOption().fields" [radioConfig]="radioConfig"></app-radio>
      </ng-container>
    </form>
  </div>
  <div class="row">
    <div class="columns large-12 medium-12">
      <app-tooltip-enabled-markup [html]="ContentConfig.text"></app-tooltip-enabled-markup>
    </div>
  </div>



  <div *ngIf="ContentConfig.additionalText; else withoutAdditionalText">
    <div class="row">
      <div class="columns large-12 medium-12">
        <div class="read-more-content" [@childAnimation]="isMoreContentOpen ? 'open' : 'closed'">
          <app-tooltip-enabled-markup [html]="ContentConfig.additionalText.teaserText.content"></app-tooltip-enabled-markup>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="large-12 columns">
        <div *ngIf="ContentConfig.tariff != null && ContentConfig.tariff.showprice; else onlyTariff" class="tariff-row">
          <a class="arrow" (click)="this.toggleMoreContent()" *ngIf="isMoreContentOpen">{{ContentConfig.additionalText.textlabelHide}}</a>
          <a class="arrow" (click)="this.toggleMoreContent()" *ngIf="!isMoreContentOpen">{{ContentConfig.additionalText.textlabelShow}}</a>
          <div class="amount">
            {{this.ContentConfig.tariff.pricePrefix ? this.ContentConfig.tariff.pricePrefix + ' ' + this.getPriceAsString() : this.getPriceAsString()}} €
          </div>
        </div>
        <ng-template #onlyTariff>
          <a class="arrow" (click)="this.toggleMoreContent()" *ngIf="isMoreContentOpen">{{ContentConfig.additionalText.textlabelHide}}</a>
          <a class="arrow" (click)="this.toggleMoreContent()" *ngIf="!isMoreContentOpen">{{ContentConfig.additionalText.textlabelShow}}</a>
        </ng-template>
      </div>
    </div>
  </div>
  <ng-template #withoutAdditionalText>
    <div class="row">
      <div class="large-12 columns">
        <div *ngIf="ContentConfig.tariff != null && ContentConfig.tariff.showprice" class="tariff-row">
          <div class="amount">
            {{this.ContentConfig.tariff.pricePrefix ? this.ContentConfig.tariff.pricePrefix + ' ' + this.getPriceAsString() : this.getPriceAsString()}} €
          </div>
        </div>
      </div>
    </div>
  </ng-template>



</div>
